import { ref, set } from "firebase/database";
import { db } from "../services/firebase";

/**
 * Custom hook to save user profile details to Firebase Realtime Database.
 * Stores data under `/Users/{uid}/Profile`.
 */
export default function useSaveUserProfile() {
    const saveUserProfile = async (uid, profileData) => {
        try {
            const userRef = ref(db, `Users/Profile/${uid}`);
            await set(userRef, {
                ...profileData,
                updatedAt: Date.now(),
            });
            console.log("✅ Profile saved successfully");
        } catch (error) {
            console.error("❌ Error saving profile:", error);
            throw error;
        }
    };

    return { saveUserProfile };
}
